export enum Role {
    Admin = 'Admin',
    CustomerUser = 'CustomerUser'
}
